export function populateMap(array, keyName, map = {}) {
  return array.reduce((map, item) => {
    map[item[keyName]] = item;
    return map;
  }, map);
}

export function toArray(object) {
  if (Array.isArray(object)) {
    return object;
  }
  if (typeof object !== "undefined") {
    return [object];
  }
  return [];
}

export function modifyLast(array, modifyFunction) {
  if (array.length > 0) {
    modifyFunction(array[array.length - 1]);
  }
  return array;
}
